// @flow
/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { List, Text } from '@zapier/common-components';

import ShareMember from '../ShareMember';

import type {
  SharedMemberObjectType,
  SharedWithType,
} from '@zapier/team/src/types';

type Props = {
  canEdit: boolean,
  emptyMessage?: string,
  onRemoveShare: (id: string | number, type: SharedMemberObjectType) => void,
  sharedWith: SharedWithType,
};

const ShareMemberList = (props: Props) => {
  return props.sharedWith.length > 0 ? (
    <List
      gap={16}
      itemRenderer={item => (
        <ShareMember
          canEdit={props.canEdit}
          onRemove={props.onRemoveShare}
          {...item}
        />
      )}
      items={props.sharedWith || []}
    />
  ) : (
    <Text color="batmobile" type="body-italic">
      {props.emptyMessage || "There's nothing here"}
    </Text>
  );
};

export default ShareMemberList;
